// Loading
setTimeout(function(){var l=document.getElementById('loader');if(l)l.classList.add('loaded')},300);
setTimeout(function(){var h=document.getElementById('heroContent');if(h)h.classList.add('entered')},800);

// Scroll nav
window.addEventListener('scroll',function(){var n=document.getElementById('nav');if(n)n.classList.toggle('scrolled',window.scrollY>50)},{passive:true});

// Smooth scroll
document.querySelectorAll('a[href^="#"]').forEach(function(a){a.addEventListener('click',function(e){var href=a.getAttribute('href');if(href.length<2)return;e.preventDefault();var t=document.querySelector(href);if(t)t.scrollIntoView({behavior:'smooth'});});});

// Counter animation
var counters=document.querySelectorAll('[data-count]');
var countObs=new IntersectionObserver(function(entries){entries.forEach(function(e){if(!e.isIntersecting)return;var el=e.target,target=parseFloat(el.dataset.count),dec=el.dataset.decimal==='true';var cur=0,step=dec?0.1:1,delay=dec?50:20;var iv=setInterval(function(){cur+=step;if(cur>=target){clearInterval(iv);el.textContent=target+(target===200?'+':target===4.9?'\u2605':'');}else{el.textContent=dec?cur.toFixed(1):Math.round(cur);}},delay);countObs.unobserve(el);});});
counters.forEach(function(c){countObs.observe(c)});

// Reveal animation
var revObs=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('vis');revObs.unobserve(e.target);}});},{threshold:0.15});
document.querySelectorAll('.pg-rev').forEach(function(el){revObs.observe(el)});

// FAQ accordion (delegated — works with Liquid-rendered FAQ items)
document.addEventListener('click',function(e){var q=e.target.closest('.pg-faq-q');if(q){var faq=q.closest('.pg-faq');if(faq)faq.classList.toggle('open');}});

// Re-observe reveals added after initial load
document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('.pg-rev:not(.vis)').forEach(function(el){revObs.observe(el)});
});

// Fallback: force-reveal everything after 3s in case IntersectionObserver fails
setTimeout(function(){
  document.querySelectorAll('.pg-rev:not(.vis)').forEach(function(el){ el.classList.add('vis'); });
}, 3000);

// DNA Helix Canvas
(function(){
var canvas=document.getElementById('helix');
if(!canvas)return;
var ctx=canvas.getContext('2d');
var w,h,mouse={x:-9999,y:-9999};
var particles=[],debris=[];
var count=80,spacing=30,radius=40;
var coreCol=[140,200,255],accentCol=[184,230,0],warmCol=[255,160,60];

function resize(){w=canvas.width=window.innerWidth;h=canvas.height=document.documentElement.scrollHeight;canvas.style.height=h+'px';}
resize();window.addEventListener('resize',resize);
function getCX(i){return w*0.38+Math.sin((i/count)*Math.PI*3)*(w*0.12);}

for(var i=0;i<count;i++){
var y=i*spacing+60,ang=(i/count)*Math.PI*12,cx=getCX(i);
for(var s=0;s<2;s++){
particles.push({hx:cx+Math.cos(ang+s*Math.PI)*radius,hy:y,x:cx+Math.cos(ang+s*Math.PI)*radius,y:y,vx:0,vy:0,sz:1.8,a:0.3+(s===0?0.1:0),s:s,i:i,hit:false,ret:0.03+Math.random()*0.015});
}}

window.addEventListener('mousemove',function(e){mouse.x=e.clientX;mouse.y=e.clientY+window.scrollY;});
var t=0;
function draw(){
ctx.clearRect(0,0,w,h);t+=0.025;
var mx=mouse.x,my=mouse.y,breakR=130,pullR=220;

particles.forEach(function(p){var ang=(p.i/count)*Math.PI*12+t;p.hx=getCX(p.i)+Math.cos(ang+p.s*Math.PI)*radius;});

for(var i=0;i<count;i++){
var a=particles[i*2],b=particles[i*2+1];if(!a||!b)continue;
var avgA=(a.a+b.a)*0.5;if(avgA<0.05)continue;
var grad=ctx.createLinearGradient(a.x,a.y,b.x,b.y);
grad.addColorStop(0,'rgba('+coreCol+','+(avgA*0.15)+')');
grad.addColorStop(0.5,'rgba('+accentCol+','+(avgA*0.08)+')');
grad.addColorStop(1,'rgba('+coreCol+','+(avgA*0.15)+')');
ctx.beginPath();ctx.moveTo(a.x,a.y);ctx.lineTo(b.x,b.y);ctx.strokeStyle=grad;ctx.lineWidth=1;ctx.stroke();
}

for(var s=0;s<2;s++){
var strand=particles.filter(function(p){return p.s===s});if(strand.length<3)continue;
ctx.beginPath();ctx.moveTo(strand[0].x,strand[0].y);
for(var i=1;i<strand.length-1;i++){ctx.quadraticCurveTo(strand[i].x,strand[i].y,(strand[i].x+strand[i+1].x)/2,(strand[i].y+strand[i+1].y)/2);}
ctx.strokeStyle='rgba('+(s===0?coreCol:accentCol)+',0.06)';ctx.lineWidth=1.5;ctx.stroke();
}

particles.forEach(function(p){
var dx=p.x-mx,dy=p.y-my,dist=Math.sqrt(dx*dx+dy*dy),col=p.s===0?coreCol:accentCol;
if(dist<breakR){
if(!p.hit){p.hit=true;var ang=Math.atan2(dy,dx),f=((breakR-dist)/breakR)*7;p.vx=Math.cos(ang)*f*(0.7+Math.random()*0.6);p.vy=Math.sin(ang)*f*(0.7+Math.random()*0.6);
for(var d=0;d<2;d++){debris.push({x:p.x,y:p.y,vx:(Math.random()-0.5)*5,vy:(Math.random()-0.5)*5,life:1,col:Math.random()>0.5?coreCol:(Math.random()>0.5?accentCol:warmCol),len:4+Math.random()*8,ang:Math.random()*Math.PI*2});}}
p.a=Math.min(0.7,p.a+0.03);
}else if(dist<pullR&&!p.hit){var pull=((pullR-dist)/pullR)*0.1;p.vx-=dx/dist*pull;p.vy-=dy/dist*pull;p.a=Math.min(0.5,p.a+pull*0.5);
}else if(p.hit){p.vx+=(p.hx-p.x)*p.ret;p.vy+=(p.hy-p.y)*p.ret;p.vx*=0.88;p.vy*=0.88;if(Math.abs(p.hx-p.x)<0.5&&Math.abs(p.hy-p.y)<0.5)p.hit=false;p.a+=(0.3-p.a)*0.03;
}else{p.vx+=(p.hx-p.x)*0.008;p.vy+=(p.hy-p.y)*0.008;p.vx*=0.96;p.vy*=0.96;p.a+=(0.3-p.a)*0.03;}
p.x+=p.vx;p.y+=p.vy;
ctx.beginPath();ctx.arc(p.x,p.y,p.sz,0,Math.PI*2);ctx.fillStyle='rgba('+col+','+p.a+')';ctx.fill();
if(p.a>0.35){ctx.beginPath();ctx.arc(p.x,p.y,p.sz*3,0,Math.PI*2);ctx.fillStyle='rgba('+col+','+(p.a*0.04)+')';ctx.fill();}
});

for(var i=debris.length-1;i>=0;i--){
var d=debris[i];d.x+=d.vx;d.y+=d.vy;d.vx*=0.97;d.vy*=0.97;d.ang+=0.1;d.life-=0.02;
if(d.life<=0){debris.splice(i,1);continue;}
var ex=Math.cos(d.ang)*d.len*d.life,ey=Math.sin(d.ang)*d.len*d.life;
ctx.beginPath();ctx.moveTo(d.x-ex*0.5,d.y-ey*0.5);ctx.lineTo(d.x+ex*0.5,d.y+ey*0.5);
ctx.strokeStyle='rgba('+d.col+','+(d.life*0.35)+')';ctx.lineWidth=1;ctx.stroke();
}

var g1=ctx.createRadialGradient(mx,my,0,mx,my,80);
g1.addColorStop(0,'rgba(140,200,255,0.025)');g1.addColorStop(0.5,'rgba(184,230,0,0.01)');g1.addColorStop(1,'transparent');
ctx.fillStyle=g1;ctx.fillRect(mx-80,my-80,160,160);
requestAnimationFrame(draw);
}
draw();
})();
